module.exports = __webpack_public_path__ + "statics/img/phone-relieve.ee70073d.png";